var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoStaredMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 100.937,
    viewBox: "0 0 148 100.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15575",
    transform: "translate(-108 -232)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25",
    cx: 3.563,
    cy: 3.563,
    r: 3.563,
    transform: "translate(108 279.5)",
    fill: "#b3c3cd"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 28",
    cx: 3.563,
    cy: 3.563,
    r: 3.563,
    transform: "translate(226.313 325.812)",
    fill: "#b3c3cd"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 26",
    transform: "translate(129.375 241.5)",
    fill: "none",
    stroke: "#bdc1c3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.563,
    cy: 3.563,
    r: 3.563,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.563,
    cy: 3.563,
    r: 3.063
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 27",
    transform: "translate(213.25 232)",
    fill: "none",
    stroke: "#bdc1c3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.563,
    cy: 3.563,
    r: 3.563,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.563,
    cy: 3.563,
    r: 3.063
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M129.375 323.081h-2.731v2.731h-.91v-2.731h-2.731v-.91h2.731v-2.731h.91v2.731h2.731z",
    fill: "#d2d7d9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "add-plus-button"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "add"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M174.062 249.456h-2.731v2.731h-.91v-2.731h-2.731v-.91h2.731v-2.731h.91v2.731h2.731z",
    fill: "#d2d7d9"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "add-plus-button"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "add"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M256 289.831h-2.731v2.731h-.91v-2.731h-2.731v-.91h2.731v-2.731h.91v2.731H256z",
    fill: "#d2d7d9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStaredMessage);
export default __webpack_public_path__ + "static/media/noStaredMessage.a63ad1f273b7273d1b2602b86b99d551.svg";
export { ForwardRef as ReactComponent };